import React from 'react'

export default class LoginForm extends React.Component {
    constructor(props) {
        super(props)
        this.state = { username: '', password: '' }
        this.onChange = this.onChange.bind(this)
        this.onSubmit = this.onSubmit.bind(this)
    }
    onChange(e) {
        this.setState({ [e.target.name]: e.target.value })
    }
    onSubmit(e) {
        e.preventDefault()
        this.setState({ submitted: true, error: null })
        if (this.props.onSubmit) {
            this.props.onSubmit(this.state.username, this.state.password)
                .catch(error => this.setState({ submitted: false, error }))
        }
    }
    render() {
        const { username, password, submitted, error } = this.state
        return (
            <div className="well login">
                <h2 className="text-center">Login</h2>
                <form onChange={this.onChange}>
                    <div className="form-group">
                        <label htmlFor="username">Username</label>
                        <input name="username" className="form-control" type="text" placeholder="Username" value={username} autoFocus />
                    </div>
                    <div className="form-group">
                        <label htmlFor="password">Password</label>
                        <input name="password" className="form-control" type="password" placeholder="Password" value={password} />
                    </div>
                    <div className="form-group">
                        <button className="btn btn-lg btn-primary btn-block" disabled={submitted} onClick={this.onSubmit}>Login</button>
                    </div>
                    {error &&
                        <div className="alert alert-danger">
                            Login failed: {this.props.error}
                        </div>
                    }
                </form>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./components/LoginForm.jsx